<template>
  <div class="login">
    <Header class="header" :title="title"></Header>
    <div class="content">
      <div class="title">
        <div>请输入您的信息</div>
        <div v-if="$route.params.mode === 'easy'" class="login-btn" @click="loginOnClick">登录</div>
      </div>
      <router-view />
    </div>
    <div v-if="floorTitle" class="floor" @click="findRecordClick">
      <span>{{floorTitle}}</span>
      <van-icon name="upgrade" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { allLogin, setAllLoginRedirect, parseUrlParams } from "@/utils/common";
export default {
  name: "Login",
  components: {
    Header
  },
  computed: {
    title() {
      const { name } = this.$route;
      let t = "";
      if (name === "general") {
        if (this.$route.params.mode === "more") t = "更多查询";
        if (this.$route.params.mode === "easy") t = "简易查询";
        if (this.$route.query.channel === "upgrades") t = "升舱";
      }
      if (name === "qrCode") {
        if (this.$route.query.channel === "upgrades") {
          t = "升舱";
        } else {
          t = "机票退改";
        }
      }
      return t;
    },
    floorTitle() {
      if (
        this.$route.name === "general" &&
        this.$route.params.mode === "more"
      ) {
        if (this.$route.query.channel === "upgrades") {
          return "查询升舱记录";
        }
        if (this.$route.query.channel === "emp") {
          const { redirect } = this.$route.query;
          if (redirect) {
            const index = redirect.indexOf("?");
            if (index !== -1) {
              const { ticketNo, type } = parseUrlParams(
                redirect.substr(index + 1)
              );
              if (!(ticketNo && type === "B")) {
                return "查询退改记录";
              }
            }
          }
        }
      }
      return "";
    }
  },
  methods: {
    loginOnClick() {
      allLogin(this.$route.query);
    },
    findRecordClick() {
      const { redirect } = this.$route.query;
      if (this.$route.query.channel === "emp") {
        window.location.href =
          redirect + (redirect.includes("?") ? "&" : "?") + "selectTabStyle=2";
      } else if (this.$route.query.channel === "upgrades") {
        window.location.href = redirect.replace("/#/list", "/#/list/processin");
      }
    }
  },
  mounted() {
    setAllLoginRedirect(this.$route.query.redirect);
  }
};
</script>

<style lang="less" scoped>
@import "../style/constant.less";
@import "../style/general.less";
.login {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background: linear-gradient(#00234e, #1088c3);
  > .header {
    background-color: transparent;
  }
  > .content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    position: relative;
    > .title {
      width: @width;
      margin: 25px auto 23px;
      font-size: 24px;
      color: #fff;
      font-weight: 400;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      > .login-btn {
        font-size: 15px;
      }
    }
    > .handle-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: transparent;
      z-index: 8;
    }
  }
  > .floor {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    height: 60px;
    font-size: @font-sm-size;
    .van-icon {
      transform: rotate(90deg);
    }
  }
}
</style>
